import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { observer } from 'mobx-react-lite';
import React, { useCallback } from 'react';
import { Handle, useStoreActions, useStoreState } from 'react-flow-renderer';
import styled, { css, keyframes } from 'styled-components';
import { UiConstants } from '../../../data/UiConstants';
import { actionEditorStore } from '../../../stores/ActionEditorStore';
import { handleClickConnect } from './handleClickConnect';
import { handleTouchDragConnectStart } from './handleTouchDragConnectStart';
const pulse = keyframes(["0%{opacity:1;}50%{opacity:0.5;}100%{opacity:1;}"]);
const StyledHandle = styled(Handle).withConfig({
  displayName: "ActionNodeHandle__StyledHandle",
  componentId: "sc-f1ab9k-0"
})(["", " ", " ", ""], props => props.$isClickConnectionSource && css(["background-color:", ";"], UiConstants.COLOR_CLICK_CONNECT_SELECTION), props => props.$isPotentialClickConnectionTarget && css(["animation:", " 1s linear infinite;"], pulse), props => props.$isPotentialClickConnectionTarget && css(["background-color:", ";"], UiConstants.COLOR_CLICK_CONNECT_TARGET));
export const ActionNodeHandle = observer(_ref => {
  let {
    nodeId,
    id,
    type,
    style
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["nodeId", "id", "type", "style"]);

  const isValidConnection = () => true; //const nodeId = useContext(NodeIdContext) as ElementId;


  const setPosition = useStoreActions(actions => actions.setConnectionPosition);
  const setConnectionNodeId = useStoreActions(actions => actions.setConnectionNodeId);
  const onConnectAction = useStoreState(state => state.onConnect);
  const onConnectStart = useStoreState(state => state.onConnectStart);
  const onConnectStop = useStoreState(state => state.onConnectStop);
  const onConnectEnd = useStoreState(state => state.onConnectEnd);
  const connectionMode = useStoreState(state => state.connectionMode);
  const handleId = id || null;
  const isTarget = type === 'target';
  const onConnectExtended = useCallback(params => {
    onConnectAction === null || onConnectAction === void 0 ? void 0 : onConnectAction(params);
  }, [onConnectAction]);
  const onTouchStart = useCallback(event => {
    handleTouchDragConnectStart(event, handleId, nodeId, setConnectionNodeId, setPosition, onConnectExtended, isTarget, isValidConnection, connectionMode, undefined, undefined, onConnectStart, onConnectStop, onConnectEnd);
  }, [handleId, nodeId, setConnectionNodeId, setPosition, onConnectExtended, isTarget, isValidConnection, connectionMode, onConnectStart, onConnectStop, onConnectEnd]);
  const onClick = useCallback(() => {
    handleClickConnect(handleId, nodeId, onConnectExtended, isTarget, isValidConnection);
  }, [handleId, nodeId, onConnectExtended, isTarget, isValidConnection]);
  let isClickConnectionSource = false;
  let isPotentialClickConnectionTarget = false;
  const {
    clickConnectionData
  } = actionEditorStore;

  if (clickConnectionData) {
    if (isTarget !== clickConnectionData.isTarget) {
      isPotentialClickConnectionTarget = true;
    } else if (nodeId === clickConnectionData.nodeId && handleId === clickConnectionData.handleId) {
      isClickConnectionSource = true;
    }
  }

  return /*#__PURE__*/React.createElement(StyledHandle, _extends({
    id: id,
    type: type,
    style: style
  }, rest, {
    onTouchStart: onTouchStart,
    onClick: onClick,
    $isClickConnectionSource: isClickConnectionSource,
    $isPotentialClickConnectionTarget: isPotentialClickConnectionTarget
  }));
});